// =========================
// TRATAMIENTO PERIODONTAL
// =========================

export const sugerirTratamientoPeriodontal = ({

  clasificacion,

  riesgo,

  historiaClinica

}) => {

  const plan = [];

  plan.push({

    fase:
      "Fase higiénica",

    procedimientos: [

      "Instrucción de higiene oral",

      "Control de placa bacteriana",

      "Profilaxis"
    ]
  });

  if (
    clasificacion?.severidad ===
    "moderada"
  ) {

    plan.push({

      fase:
        "Terapia periodontal",

      procedimientos: [

        "Raspado y alisado radicular",

        "Reevaluación periodontal en 4-6 semanas"
      ]
    });
  }

  if (
    clasificacion?.severidad ===
    "severa"
  ) {

    plan.push({

      fase:
        "Terapia periodontal avanzada",

      procedimientos: [

        "Raspado y alisado radicular por cuadrantes",

        "Valoración quirúrgica periodontal",

        "Reevaluación periodontal"
      ]
    });
  }

  if (
    historiaClinica
      ?.habitos
      ?.tabaquismo
  ) {

    plan.push({

      fase:
        "Control de factores de riesgo",

      procedimientos: [

        "Consejería para suspensión de tabaquismo"
      ]
    });
  }

  if (
    historiaClinica
      ?.antecedentesMedicos
      ?.diabetes
  ) {

    plan.push({

      fase:
        "Control sistémico",

      procedimientos: [

        "Monitorear control glucémico",

        "Interconsulta médica si es necesario"
      ]
    });
  }

  let mantenimiento =
    "Cada 6 meses";

  if (
    riesgo?.riesgo ===
    "Moderado"
  ) {

    mantenimiento =
      "Cada 4 meses";
  }

  if (
    riesgo?.riesgo ===
    "Alto"
  ) {

    mantenimiento =
      "Cada 3 meses";
  }

  return {

    mantenimiento,

    plan
  };
};